module.exports = __webpack_public_path__ + "static/media/filename (5).62b17dc2.png";